import React from 'react';

import PropTypes from 'prop-types';

import CommercialSidebar from '@/components/CommercialPage/CommercialSidebar';
import PageHeader from '@/components/common/PageHeader';

const CommercialLayout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-gray-50">
    <PageHeader />
    <div className="flex-1 flex overflow-hidden">
      <CommercialSidebar />
      <main className="flex-1 flex overflow-hidden bg-[#eeeeee]">{children}</main>
    </div>
  </div>
);

CommercialLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CommercialLayout;
